import { apiFetch } from '@m/utils/http';

import type { EnterpriseInvitationUser } from '@m/types/api/EnterpriseInvitation';

/** Raw response shape from `GET /enterprise/invitation/{token}`. */
export type EnterpriseSubscriptionInviteView = {
  email: string | null;
  firstname: string | null;
  lastname: string | null;
  phone: string | null;
  token: string;
};

export function toEnterpriseInvitationUser(
  view: EnterpriseSubscriptionInviteView,
): EnterpriseInvitationUser {
  return {
    token: view.token,
    email: view.email ?? undefined,
    firstName: view.firstname ?? undefined,
    lastName: view.lastname ?? undefined,
    phoneNumber: view.phone ?? undefined,
  };
}

export const EnterpriseInvitationService = {
  parseInviteToken: ({ token }: { token: string }) =>
    apiFetch<EnterpriseSubscriptionInviteView>(`/enterprise/invitation/${token}`),

  redeemInvite: ({ token }: { token: string }) =>
    apiFetch(`/enterprise/invitation/${token}/redeem`, { method: 'POST' }),

  // this is used for bedrock we send a token as well as a employeeUuid
  claimRedemptionToken: ({ token, employeeId }: { employeeId: string; token: string }) =>
    apiFetch(`/customer/account/${token}/redeem`, {
      method: 'POST',
      body: {
        employeeId,
      },
    }),
};
